var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-container"},[_c('Layout',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('div',{staticClass:"blog-main"},[_c('BlogView')],1)]},proxy:true},{key:"right",fn:function(){return [_c('div',{staticClass:"blog-right"},[_c('Sidebar',{on:{"select":_vm.handleSelect}})],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }